import { STATUS_META } from "@/lib/format";

export const StatusBadge = ({ status, testId }) => {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100" };
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${m.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />{m.label}
    </span>
  );
};

export const SourceTag = ({ source }) => (
  <span className={`rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${source === "web_upload" ? "bg-[#00573F]/10 text-[#00573F]" : "bg-slate-200 text-slate-600"}`}>
    {source === "web_upload" ? "Web file" : "Portal"}
  </span>
);

export const Sap = ({ code }) => (
  <span className="rounded bg-red-50 px-1.5 py-0.5 font-mono text-[11px] font-semibold text-[#D60000]">{code}</span>
);
